export default __webpack_public_path__ + "static/media/MilanToRome.9af2967e.webp";